import ModalHeaderCloseCustom from "./ModalHeaderCloseCustom";

export default function HeaderModalCloseButton(props) {
    const { title = "" } = props;
    return <ModalHeaderCloseCustom {...props} title={title} />;
}
